<div class="container">
  <div class="header">
    <span class="label">{{ header }}</span>
    <cs-icon-button
      icon="fi-x"
      iconFontSize="12"
      size="12"
      color="secondary"
      (buttonClick)="onCancel()"
    ></cs-icon-button>
  </div>
  <div class="body-container">
    <div class="body">
      <div class="text">
        {{ message }}
        <span class="mark" (click)="contactSupport()">Contact support</span>
      </div>
    </div>
    <div class="btn">
      <cs-button [label]="'Go back'" [color]="'primary'" (buttonClick)="onConfirm()"></cs-button>
    </div>
  </div>
</div>
